<div class="d-flex flex-stretch align-items-center">
    <div class="flex-1" kui-action (click)="!field.readonly && onEdit()">
        @if (!value?.preview) {
            <span>{{ "SHARED.NONE" | translate }}</span>
        }
        @if (value?.preview) {
            <img [style.max-width]="field.width ? field.width + 'px' : '150px'" [src]="value.preview" />
        }
    </div>
    @if (!field.readonly) {
        <div>
            <kui-icon name="edit" kui-action class="muted ml-2" (click)="onEdit()" size="sm"></kui-icon>
            <kui-icon name="times" kui-action class="muted ml-2" (click)="onClear()" size="sm"></kui-icon>
        </div>
    }
</div>

@if (field.required && touched && !value?.original) {
    <div class="invalid-feedback d-block">
        <div>{{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}</div>
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
